import React from "react";
import { HeaderContext } from "@tanstack/react-table";
import CaButton from "../button/CaButton";
import { SortingArrowDownIcon } from "@/icons/primary/sorting-arrow-down-icon";

export type CaDataTableSortingButtonProps = {
  label: string;
  column: HeaderContext<any, any>["column"];
};

function CaDataTableSortingButton({ label, column }: CaDataTableSortingButtonProps) {
  return (
    <CaButton
      size='small'
      minimal
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      className='flex items-center gap-2'
    >
      <span>{label}</span>
      {column.getIsSorted() === "asc" ? (
        <SortingArrowDownIcon
          className='!text-mid-neutral-1'
          style={{
            transform: "rotate(180deg)",
          }}
        />
      ) : column.getIsSorted() === "desc" ? (
        <SortingArrowDownIcon className='!text-mid-neutral-1' />
      ) : null}
    </CaButton>
  );
}

export default CaDataTableSortingButton;
